export default __webpack_public_path__ + "static/media/pedidosOs.c0f1184a.png";